import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/provider";
import { ProtectedRoute } from "./auth/protected-route";
import { LandingPage } from "./pages/landing";
import { LoginPage } from "./pages/login";
import { DashboardPage } from "./pages/dashboard";
import { ProfilePage } from "./pages/profile";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
